module.exports = __webpack_public_path__ + "static/media/16-RotHeatExchanger - Water cool - El heat.342456dd.png";